import { render, staticRenderFns } from "./ReportDrugClaim.vue?vue&type=template&id=40449ad0&scoped=true"
import script from "./ReportDrugClaim.vue?vue&type=script&lang=js"
export * from "./ReportDrugClaim.vue?vue&type=script&lang=js"
import style0 from "./ReportDrugClaim.vue?vue&type=style&index=0&id=40449ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40449ad0",
  null
  
)

export default component.exports